<template>
  
  <div>
    <dx-popup
      :width="350"
      :height="300"
      :show-title="false"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :visible.sync = "isShown"
      :on-hiding = "closeform"
    >

    <v-container  grid-list-xl pt-0>
			<app-card>

     <v-layout row wrap>
        <v-flex sm12>
          AFSPRAAK FORMULIER
        </v-flex>
        <v-flex sm12>
        <dx-button text="Notitie opmaken" @click="btnNote" />
        </v-flex>
     </v-layout>
			</app-card>
    </v-container>

    </dx-popup>
  </div>

</template>

<style>
.dx-popup-content {
    padding: 0px;
}
.container {
  padding: 0px;
}
</style>

<script>

import { DxButton, DxPopup, DxPopover } from 'devextreme-vue';

export default {
  components: {
    DxButton, DxPopup, DxPopover
  },
   props: {
  },
  data: function() {
    return {
      showForm : false,
      position: {
        offset: '0, 2',
        at: 'bottom',
        my: 'top',
        collision: 'fit flip'
      }
    };
  },
 mounted() {

  },
  computed: {
     isShown () {
         return this.showForm;
     }
  },
  methods: {
      closeform () {
          console.log ("Closing form");
          this.showForm = false;
      },
      show () {
          console.log ("Show form");
          this.showForm = true;
      },
      btnAppoint () {
          console.log ("afspraak klik");
      },
      btnNote () {
          console.log ("notitie klik");
      }
  }
};
</script>